export const permissions = [
  { key: "overview", label: "概览" },
  { key: "members", label: "用户管理" },
  { key: "merchants", label: "商家管理" },
  { key: "articles", label: "文章管理" },
  { key: "orders", label: "订单管理" },
  { key: "funds", label: "资金流水" },
  { key: "withdrawals", label: "提现审核" },
  { key: "applications", label: "商家申请" },
  { key: "notice", label: "公告与提示" },
  { key: "pages", label: "用户协议" },
  { key: "admins", label: "管理员列表" },
  { key: "settings", label: "系统配置" },
  { key: "security", label: "权限设置" },
];
export const roleLabel = (value) =>
  ({ user: "普通用户", merchant: "商家", agent: "商家", promoter: "推广员" })[
    value
  ] || "普通用户";
export const statusLabel = (value) =>
  ({
    pending: "待处理",
    paid: "已支付",
    cancelled: "已取消",
    approved: "已通过",
    rejected: "已驳回",
    published: "已发布",
    scheduled: "定时",
    draft: "草稿",
    hidden: "隐藏",
  })[value] ||
  value ||
  "-";
export const fundTypeLabel = (value) =>
  ({
    sell: "内容收入",
    commission: "上级抽成",
    anchor_commission: "商家抽佣",
    recharge: "余额充值",
    buy: "购买内容",
    withdraw: "提现冻结",
    withdraw_refund: "提现驳回退回",
  })[value] ||
  value ||
  "-";
export const money = (value) =>
  Number.isFinite(Number(value)) ? Number(value).toFixed(2) : "0.00";
